import Vue from 'vue'
import Vuetify from 'vuetify/lib'
import 'vuetify/src/stylus/app.styl'
import colors from '@/mixins/Colors'

Vue.use(Vuetify, {
    iconfont: 'md',
    theme: {
        primary: colors.primaryHTML,
        secondary: colors.secondaryHTML,
        accent: colors.complementHTML,
        error: colors.dangerHTML,
        warning: colors.warningHTML,
        info: colors.infoHTML,
        success: colors.successHTML,
    },
})
